import { render } from "./index.vue?vue&type=template&id=33ec43fc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=33ec43fc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-33ec43fc"
/* hot reload */
if (module.hot) {
  script.__hmrId = "33ec43fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33ec43fc', script)) {
    api.reload('33ec43fc', script)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=33ec43fc&scoped=true", () => {
    api.rerender('33ec43fc', render)
  })

}

script.__file = "src/layout/components/Sidebar/index.vue"

export default script